import React from "react";
import { RouteData, SiteData } from "react-static";
import { Location } from "@reach/router";
//
import Seo from "./seo";
//
const CombineMeta = routeMeta => (
  <Location>
    {({ location }) => (
      <SiteData>
        {({ meta, siteMeta }) => (
          <Seo
            location={location}
            site={siteMeta}
            meta={{ ...meta, ...routeMeta }}
          />
        )}
      </SiteData>
    )}
  </Location>
);
//
export default () => (
  <RouteData>{({ meta }) => <CombineMeta {...meta} />}</RouteData>
);
